
import React, { useState } from "react";
import logo from "./assets/logo.png";
import { apiFetch } from "./api";

function ForgotPassword({ setPage }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);
    setMessage("");

    try {
      const res = await apiFetch("/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email: email.trim() })
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data.error || "Unable to process request.");
      } else {
        setMessage(
          "If an eligible MukBi account exists for this email, a password reset link will be sent."
        );
      }
    } catch (err) {
      console.error("Forgot password error:", err);
      setMessage("Unable to process request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#f5f6fa"
    }}>
      <div style={{
        background: "white",
        padding: 30,
        borderRadius: 10,
        boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
        width: 320,
        textAlign: "center"
      }}>
        <h1>Mukbi CRM</h1>

        <img
          src={logo}
          alt="Mukbi CRM"
          style={{ width: 120 }}
        />

        <h2>Forgot Password</h2>

        <p style={{ fontSize: 14, color: "#555" }}>
          Enter your registered email address to request
          a password reset link.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            maxLength={254}
            style={{
              boxSizing: "border-box",
              width: "100%",
              padding: 10,
              margin: "10px 0",
              borderRadius: 6,
              border: "1px solid #ccc"
            }}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: 10,
              background: "#2c3e50",
              color: "white",
              border: "none",
              borderRadius: 6,
              cursor: loading ? "wait" : "pointer"
            }}
          >
            {loading ? "Please wait..." : "Send Reset Link"}
          </button>
        </form>

        {message && (
          <p role="status" style={{
            marginTop: 15,
            fontSize: 13,
            color: "#34495e"
          }}>
            {message}
          </p>
        )}

        <p
          onClick={() => setPage("login")}
          style={{
            color: "#3498db",
            cursor: "pointer",
            marginTop: 20
          }}
        >
          Back to Login
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
